import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ShopContextProvider from './Context/ShopContext';
import { loadClinicConfig } from './clinicaConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

async function bootstrap() {
  await loadClinicConfig();
  root.render(
      <ShopContextProvider>
        <App />
      </ShopContextProvider>
  );
}

bootstrap();
